<template>
	<div class="row" :class="{collapsed: collapsed}">
		<slot></slot>
	</div>
</template>

<script>

	export default {
		props: {
			collapsed: {
				type: Boolean,
				default: false
			}
		},
		mounted() {}
	}
	
</script>

<style lang="scss" scoped>

	@import './../../sass/variables';

	.row {
		display: flex;

		&.collapsed {
			margin-bottom: $gutter;

			> * + * {
				margin-left: $gutter;
			}

		}
	}
</style>